

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {ResponsavelVisualizador} from '@/model/resource/ResponsavelVisualizador'
import {ResponsavelVisualizadorCollection} from '@/model/collection/ResponsavelVisualizadorCollection'
import {ListResponsavelVisualizadorSchema} from '@/schema/resource/ResponsavelVisualizador/ListResponsavelVisualizadorSchema'
import {CsvResponsavelVisualizadorSchema} from '@/schema/resource/ResponsavelVisualizador/CsvResponsavelVisualizadorSchema'

@Component
export default class ListResponsavelVisualizadorView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListResponsavelVisualizadorSchema()
  collection = new ResponsavelVisualizadorCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponsavelVisualizador) {
    Helper.pushByName('editResponsavelVisualizador', item.$id)
  }

  async removeItem(item: ResponsavelVisualizador) {
    await new DialogRemove(item).confirm(() =>
      item.removeResponsavelVisualizador()
    )
    await this.collection.listResponsavelVisualizador()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponsavelVisualizadorCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvResponsavelVisualizador()
    new CsvResponsavelVisualizadorSchema().downloadCsv(csv.all())
  }
}
